import { Box, Button, Card, CardContent, CardHeader, FormHelperText, Grid, IconButton, useTheme } from '@mui/material';
import {
    CurrencyInput,
    DateInput,
    MultiSelectInput,
    NPSRatingInput,
    NumberInput,
    RadioInput,
    SelectInput,
    shouldQuestionOrScreenVisible,
    StarsRatingInput,
    TextareaInput,
    TextInput,
    TitleText,
    UploadInput,
} from './Questions';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Delete, Edit, Save } from '@mui/icons-material';
import { useAuth } from '../../hooks/useAuth';

const RepeatableScreen = forwardRef((props, ref) => {
    const {
        questionsList = [],
        currentScreenData = {},
        questionsListToValidate = [],
        cardList = [],
        handleRepeatableDataSave = () => {},
        validate = () => {},
        error = '',
        setRepeatScreenError = () => {},
        isLock = false,
        handleSetVisibility = () => {},
        currentStep = '',
        contactId = '',
    } = props;
    const [innerScreens, setInnerScreens] = useState([]);

    useEffect(() => {
        setInnerScreens([]);
        setRepeatScreenError('');

        if (cardList?.length) {
            setInnerScreens([...cardList]);
        } else {
            handleMore();
        }
        // setTimeout(() => {
        // }, 500);
    }, [currentStep]);

    useImperativeHandle(ref, () => ({
        allCardsDataSaveHandler() {
            return handleAllCardDataSave();
        },
    }));

    const getNewCard = () => {
        const cardQuestionsList = questionsList?.map((c) => {
            return {
                ...c,
                isAnswerExist: false,
                answer: null,
                // answer: c.Default_Value__c ? c.Default_Value__c : '',
            };
        });
        const newCardScreen = {
            id: `${Math.random()}`,
            questions: [...cardQuestionsList],
            filesId: `${Math.random()}`,
        };

        return newCardScreen;
    };

    const handleMore = () => {
        const newCardScreen = getNewCard();
        setInnerScreens((prevInnerScreens) => [...prevInnerScreens, newCardScreen]);
    };

    const handleDelete = (id) => {
        const updatedList = innerScreens.filter((c) => c.id !== id);

        if (updatedList.length) {
            setInnerScreens([...updatedList]);
        } else {
            const newCardScreen = getNewCard();

            setInnerScreens([...updatedList, newCardScreen]);
        }

        handleRepeatableDataSave(updatedList);
    };

    const handleCardScreenDataChange = (newValue, questionId, cardId, notValidate) => {
        // debugger;
        setInnerScreens((innerScreens) => {
            notValidate = notValidate && !newValue;
            const cardScreen = innerScreens.find((c) => c.id === cardId);
            const questionsList = cardScreen?.questions?.map((question) => {
                if (question?.Id === questionId) {
                    const answerValue = typeof newValue === 'string' ? newValue.trim() : newValue;
                    return {
                        ...question,
                        answer: answerValue,
                    };
                }
                return question;
            });
            const validatedQuestions = questionsList.map((cQuestion) => {
                const shouldVisible = shouldQuestionOrScreenVisible({
                    conditionalRequirement: cQuestion?.Condition_Requirement__c,
                    conditionalLogic: cQuestion?.Condition_Logic__c,
                    conditionList: cQuestion?.Conditions2__r?.records,
                    questionList: [...questionsListToValidate, ...questionsList],
                });
                if (!shouldVisible) {
                    if (cQuestion.hasOwnProperty('error')) {
                        delete cQuestion.error;
                    }
                    return cQuestion;
                }
                const error = validate(cQuestion);

                if ((cQuestion.Is_Required__c === 'Yes' || !cQuestion.Is_Required__c) && cQuestion?.Id === questionId && !notValidate) {
                    if (error) {
                        return {
                            ...cQuestion,
                            error,
                        };
                    } else {
                        if (cQuestion.hasOwnProperty('error')) {
                            delete cQuestion.error;
                        }
                        return cQuestion;
                    }
                }
                return cQuestion;
            });
            const newCardScreen = {
                ...cardScreen,
                questions: validatedQuestions,
            };
            const newInnerScreenList = innerScreens.map((c) => {
                if (c.id === newCardScreen.id) {
                    return newCardScreen;
                }
                return c;
            });
            return newInnerScreenList;
        });
    };

    console.log('innerScreens: ', innerScreens);

    const handleDataSave = ({ callback, id }) => {
        const cardScreen = innerScreens.find((c) => c.id === id);
        const validatedQuestions = cardScreen?.questions.map((cQuestion) => {
            const shouldVisible = shouldQuestionOrScreenVisible({
                conditionalRequirement: cQuestion?.Condition_Requirement__c,
                conditionalLogic: cQuestion?.Condition_Logic__c,
                conditionList: cQuestion?.Conditions2__r?.records,
                questionList: [...questionsListToValidate, ...cardScreen?.questions],
            });
            if (!shouldVisible) {
                if (cQuestion.hasOwnProperty('error')) {
                    delete cQuestion.error;
                }
                if (cQuestion.hasOwnProperty('answer')) {
                    delete cQuestion.answer;
                }
                return { ...cQuestion, skipped: true, isVisible: false };
            }

            if (cQuestion.Is_Required__c === 'Yes' || !cQuestion.Is_Required__c) {
                const error = validate(cQuestion);
                if (error) {
                    return {
                        ...cQuestion,
                        error,
                        skipped: false,
                        isVisible: true,
                    };
                } else {
                    if (cQuestion.hasOwnProperty('error')) {
                        delete cQuestion.error;
                    }
                    return {
                        ...cQuestion,
                        skipped: false,
                        isVisible: true,
                    };
                }
            }
            return { ...cQuestion, skipped: false, isVisible: true };
        });

        const newCardScreen = {
            ...cardScreen,
            questions: validatedQuestions,
        };

        const isAlreadyExist = cardList.find((c) => {
            if (c.id === newCardScreen.id) {
                return true;
            }
            return false;
        });

        let newInnerScreenList = [];

        if (isAlreadyExist) {
            newInnerScreenList = cardList.map((c) => {
                if (c.id === newCardScreen.id) {
                    return newCardScreen;
                }
                return c;
            });
        } else {
            newInnerScreenList = [...cardList, newCardScreen];
        }

        setInnerScreens(newInnerScreenList);

        const errors = validatedQuestions.filter((cQuestion) => {
            if (cQuestion.error) {
                return true;
            }
            return false;
        });

        if (Object.keys(errors).length === 0) {
            handleRepeatableDataSave(newInnerScreenList);
            callback();
        }
    };

    const handleAllCardDataSave = () => {
        let updatedInnerScreens = [...innerScreens];
        let errors = [];

        for (let index = 0; index < innerScreens.length; index++) {
            const cardScreen = innerScreens[index];

            const validatedQuestions = cardScreen?.questions.map((cQuestion) => {
                const shouldVisible = shouldQuestionOrScreenVisible({
                    conditionalRequirement: cQuestion?.Condition_Requirement__c,
                    conditionalLogic: cQuestion?.Condition_Logic__c,
                    conditionList: cQuestion?.Conditions2__r?.records,
                    questionList: [...questionsListToValidate, ...cardScreen?.questions],
                });
                if (!shouldVisible) {
                    if (cQuestion.hasOwnProperty('error')) {
                        delete cQuestion.error;
                    }
                    if (cQuestion.hasOwnProperty('answer')) {
                        delete cQuestion.answer;
                    }
                    return { ...cQuestion, skipped: true, isVisible: false };
                }

                if (cQuestion.Is_Required__c === 'Yes' || !cQuestion.Is_Required__c) {
                    const error = validate(cQuestion);
                    if (error) {
                        return {
                            ...cQuestion,
                            error,
                            skipped: false,
                            isVisible: true,
                        };
                    } else {
                        if (cQuestion.hasOwnProperty('error')) {
                            delete cQuestion.error;
                        }
                        return {
                            ...cQuestion,
                            skipped: false,
                            isVisible: true,
                        };
                    }
                }
                return { ...cQuestion, skipped: false, isVisible: true };
            });

            const updatedCardScreen = {
                ...cardScreen,
                questions: validatedQuestions,
            };

            updatedInnerScreens = updatedInnerScreens.map((c) => {
                if (c.id === updatedCardScreen.id) {
                    return updatedCardScreen;
                }
                return c;
            });

            const cCardErrors = validatedQuestions.filter((cQuestion) => {
                if (cQuestion.error) {
                    return true;
                }
                return false;
            });

            errors = [...errors, ...cCardErrors];
        }
        console.log('handleAllCardDataSave...', errors, updatedInnerScreens);

        setInnerScreens(updatedInnerScreens);
        if (Object.keys(errors).length === 0) {
            // handleRepeatableDataSave(updatedInnerScreens);
            return updatedInnerScreens;
        }
        return null;
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                maxWidth: '100%',
            }}
        >
            <Grid
                container
                spacing={2}
                sx={{
                    marginTop: '1rem',
                    marginBottom: '2rem',

                    justifyContent: 'center', //middle
                }}
            >
                {innerScreens?.map((currentCardScreen, i) => {
                    return (
                        <Grid
                            item
                            key={currentCardScreen.id}
                            sx={(theme) => ({
                                [theme.breakpoints.down('sm')]: {
                                    width: '100%',
                                },

                                '@media (max-width:799px)': {
                                    minWidth: '100%',
                                    maxWidth: '100%',
                                },
                            })}
                        >
                            <IndivisualCardScreen
                                id={currentCardScreen.id}
                                name={currentScreenData.Name + ' ' + (i + 1)}
                                // count={i + 1}
                                count={currentCardScreen.filesId}
                                questions={currentCardScreen.questions}
                                questionsListToValidate={questionsListToValidate}
                                handleDelete={() => handleDelete(currentCardScreen.id)}
                                handleCardScreenDataChange={handleCardScreenDataChange}
                                handleDataSave={handleDataSave}
                                isLock={isLock}
                                currentStep={currentStep}
                                handleSetVisibility={handleSetVisibility}
                                contactId={contactId}
                            />
                        </Grid>
                    );
                })}
            </Grid>

            {!isLock && (
                <Box
                    width={'100%'}
                    sx={(theme) => ({
                        // button in middle
                        display: 'flex',
                        justifyContent: 'center',

                        marginTop: '2.5rem',
                    })}
                >
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={handleMore}
                        sx={(theme) => ({
                            marginRight: '1rem',
                            [theme.breakpoints.down('sm')]: {
                                width: '100%',
                                marginBottom: '8px',
                                marginRight: '0',
                            },
                        })}
                    >
                        Add More
                    </Button>
                </Box>
            )}
            {error && <FormHelperText error>{error}</FormHelperText>}
        </Box>
    );
});

const IndivisualCardScreen = ({
    id,
    name,
    questions,
    handleDelete = () => {},
    handleCardScreenDataChange = () => {},
    handleDataSave = () => {},
    isLock = false,
    count,
    handleSetVisibility = () => {},
    currentStep = '',
    questionsListToValidate = [],
    contactId,
}) => {
    // const [editDisable, setEditDisable] = useState(false);
    const theme = useTheme();
    const { getUserDetailsNotAsync } = useAuth();
    let userDetails = getUserDetailsNotAsync();

    // useEffect(() => {
    //     for (let index = 0; index < questions.length; index++) {
    //         const element = questions[index];

    //         if (element.answer) {
    //             setEditDisable(true);
    //             break;
    //         }
    //     }
    // }, []);

    // const handleEdit = () => {
    //     setEditDisable(!editDisable);
    // };

    // const handleSave = () => {
    //     handleDataSave({ callback: handleEdit, id });
    // };

    const questionListOnConditions = questions.filter((cQuestion) => {
        const shouldVisible = shouldQuestionOrScreenVisible({
            conditionalRequirement: cQuestion?.Condition_Requirement__c,
            conditionalLogic: cQuestion?.Condition_Logic__c,
            conditionList: cQuestion?.Conditions2__r?.records,
            questionList: [...questionsListToValidate, ...questions],
        });
        if (shouldVisible) {
            handleSetVisibility(true, cQuestion.Id, currentStep, id);
            return true;
        }
        handleSetVisibility(false, cQuestion.Id, currentStep, id);
        return false;
    });

    return (
        <Card
            sx={{
                minWidth: 400,
                maxWidth: 400,
                minHeight: { xs: '0px', sm: 400 },

                overflow: 'auto',
                boxShadow: 'none',
                border: `1px solid ${theme.palette.border.neutralPrimary}`,
                borderRadius: '12px',

                '@media (max-width:799px)': {
                    minWidth: '100%',
                    maxWidth: '100%',
                },

                [theme.breakpoints.down('sm')]: {
                    minWidth: '100%',
                    maxWidth: '100%',
                },
            }}
        >
            <CardHeader
                sx={{
                    padding: '16px',
                    paddingBottom: 0,
                }}
                title={name}
                action={
                    !isLock ? (
                        <>
                            {/* {!editDisable ? (
                                <IconButton aria-label="Save" size="small" onClick={handleSave}>
                                    <Save />
                                </IconButton>
                            ) : (
                                <IconButton aria-label="Edit" size="small" onClick={handleEdit}>
                                    <Edit />
                                </IconButton>
                            )} */}

                            <IconButton aria-label="Delete" color="error" size="small" onClick={handleDelete}>
                                <Delete />
                            </IconButton>
                        </>
                    ) : (
                        ''
                    )
                }
            />
            <CardContent
                sx={{
                    '&>*:not(:last-child)': {
                        marginBottom: '1rem',

                        '&.titleText': {
                            marginBottom: '0.5rem',
                        },
                    },
                }}
            >
                {questionListOnConditions.map((cQuestion, index) => {
                    if (cQuestion.Type__c === 'Picklist') {
                        return <SelectInput key={cQuestion.Id} questionNumber={index + 1} question={cQuestion} screenNo={id} handleDataChange={handleCardScreenDataChange} disabled={isLock} />;
                    }
                    if (cQuestion.Type__c === 'Radio') {
                        return <RadioInput key={cQuestion.Id} questionNumber={index + 1} question={cQuestion} screenNo={id} handleDataChange={handleCardScreenDataChange} disabled={isLock} />;
                    }
                    if (cQuestion.Type__c === 'Text') {
                        return <TextInput key={cQuestion.Id} questionNumber={index + 1} question={cQuestion} screenNo={id} handleDataChange={handleCardScreenDataChange} disabled={isLock} />;
                    }
                    if (cQuestion.Type__c === 'CSAT') {
                        return <StarsRatingInput key={cQuestion.Id} questionNumber={index + 1} question={cQuestion} screenNo={id} handleDataChange={handleCardScreenDataChange} disabled={isLock} />;
                    }
                    if (cQuestion.Type__c === 'NPS') {
                        return (
                            <NPSRatingInput
                                key={cQuestion.Id}
                                questionNumber={index + 1}
                                question={cQuestion}
                                screenNo={id}
                                handleDataChange={handleCardScreenDataChange}
                                disabled={isLock}
                                isCardView={true}
                            />
                        );
                    }
                    if (cQuestion.Type__c === 'Date') {
                        return <DateInput key={cQuestion.Id} questionNumber={index + 1} question={cQuestion} screenNo={id} handleDataChange={handleCardScreenDataChange} disabled={isLock} />;
                    }
                    if (cQuestion.Type__c === 'Number') {
                        return <NumberInput key={cQuestion.Id} questionNumber={index + 1} question={cQuestion} screenNo={id} handleDataChange={handleCardScreenDataChange} disabled={isLock} />;
                    }
                    if (cQuestion.Type__c === 'Currency') {
                        return <CurrencyInput key={cQuestion.Id} questionNumber={index + 1} question={cQuestion} screenNo={id} handleDataChange={handleCardScreenDataChange} disabled={isLock} />;
                    }
                    if (cQuestion.Type__c === 'Multi-select') {
                        return <MultiSelectInput key={cQuestion.Id} questionNumber={index + 1} question={cQuestion} screenNo={id} handleDataChange={handleCardScreenDataChange} disabled={isLock} />;
                    }
                    if (cQuestion.Type__c === 'File') {
                        return (
                            <UploadInput
                                parentId={cQuestion.Id + '-' + (contactId ? contactId : userDetails.contact.id) + '-' + count}
                                disabled={isLock}
                                key={cQuestion.Id}
                                questionNumber={index + 1}
                                question={cQuestion}
                                screenNo={id}
                                handleDataChange={handleCardScreenDataChange}
                                displayItem={12}
                            />
                        );
                    }
                    if (cQuestion.Type__c === 'Textarea') {
                        return <TextareaInput key={cQuestion.Id} questionNumber={index + 1} question={cQuestion} screenNo={id} handleDataChange={handleCardScreenDataChange} disabled={isLock} />;
                    }
                    if (cQuestion.Type__c === 'Display Text') {
                        return <TitleText key={cQuestion.Id} question={cQuestion} />;
                    }
                    return <></>;
                })}
            </CardContent>
        </Card>
    );
};

export default RepeatableScreen;
